import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Registers the service worker (which is what lets the app open with no network) and offers a
 * new version when one is ready. Deliberately a prompt, never an automatic reload: a surprise
 * refresh would throw away a transaction the user is halfway through typing.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError: (error) => console.warn("Service worker registration failed", error),
  });

  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-3 bottom-20 z-[70] mx-auto flex max-w-md items-center gap-3 rounded-lg bg-ink px-4 py-2.5 text-sm text-page shadow-lg md:bottom-6"
    >
      <span className="flex-1">A new version of Ledger is ready.</span>
      <button type="button" onClick={() => void updateServiceWorker(true)} className="font-semibold underline">
        Reload
      </button>
    </div>
  );
}
